import {registerDataRouterApp} from '@github-ui/react-core/register-app'
import {PullRequestErrorState} from './components/PullRequestErrorState'
import {pullRequestsAppBuilder} from './config/app-builder'
import {pullRequestsCommitsRoute} from './routes/commits-route'
import {CommitsEntrypointFuture} from './routes/CommitsFuture'
import type {RouteObject} from '@github-ui/react-router'
import {pullRequestsLayoutRoute} from './routes/layout-route'
import {LayoutEntrypoint} from './routes/Layout'
import {pullRequestsFilesRoute, pullRequestsFilesWithRangeRoute} from './routes/files-route'
import {pullRequestsChangesRoute, pullRequestsChangesWithRangeRoute} from './routes/changes-route'
import {FilesEntrypointFuture, FilesWithRangeEntrypointFuture} from './routes/FilesFuture'
import {ChangesEntrypointFuture, ChangesWithRangeEntrypointFuture} from './routes/ChangesFuture'
import {pullRequestsConversationsRoute} from './routes/conversations-route'
import {ConversationsEntrypoint} from './routes/Conversations'
import {isFeatureEnabled} from '@github-ui/feature-flags'

const conversationRoute: () => RouteObject[] = () => {
  if (!isFeatureEnabled('prs_conversations_react')) return []

  return [
    pullRequestsConversationsRoute.toRoute({
      Component: ConversationsEntrypoint,
    }),
  ]
}

const commitsRouteWithLayout: () => RouteObject[] = () => [
  pullRequestsLayoutRoute.toRoute({
    ErrorBoundary: PullRequestErrorState,
    Component: LayoutEntrypoint,
    children: [
      ...conversationRoute(),
      pullRequestsCommitsRoute.toRoute({
        Component: CommitsEntrypointFuture,
      }),
    ],
  }),
]

const dataRouterRoutes: () => RouteObject[] = () => [
  pullRequestsLayoutRoute.toRoute({
    ErrorBoundary: PullRequestErrorState,
    Component: LayoutEntrypoint,
    children: [
      ...conversationRoute(),
      pullRequestsCommitsRoute.toRoute({
        Component: CommitsEntrypointFuture,
      }),
      pullRequestsFilesRoute.toRoute({
        Component: FilesEntrypointFuture,
      }),
      pullRequestsFilesWithRangeRoute.toRoute({
        Component: FilesWithRangeEntrypointFuture,
      }),
      pullRequestsChangesRoute.toRoute({
        Component: ChangesEntrypointFuture,
      }),
      pullRequestsChangesWithRangeRoute.toRoute({
        Component: ChangesWithRangeEntrypointFuture,
      }),
    ],
  }),
]

export const pullRequestsApp = pullRequestsAppBuilder.createDataRouterAppFromRoutes(params => {
  // The `react_data_router_pull_request_files` feature flag is set in the controller when the
  // user is enrolled in the New Files Changed feature preview
  if (params.isEnabled('react_data_router_pull_request_files')) {
    return dataRouterRoutes()
  }

  return commitsRouteWithLayout()
})

registerDataRouterApp(pullRequestsApp)
